"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALIGN_SELF_OPTIONS = void 0;
var ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
exports.ALIGN_SELF_OPTIONS = ALIGN_SELF_OPTIONS;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/layout/BoxConstants.js
// module id = 747
// module chunks = 209 210 211 212